import { assert } from '@ember/debug';

export default function assertHelper(text: string, condition?: boolean): void {
  assert(text, condition);
}
